// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".head[data-v-3fe857a2] {\n  color: var(--magic-tertiary, #311261);\n}\n\n.date[data-v-3fe857a2] {\n  color: var(--magic-tertiary, #311261);\n}\n\n.subject[data-v-3fe857a2] {\n  color: var(--magic-tertiary, #311261);\n}\n\n.body[data-v-3fe857a2] {\n  color: rgba(49, 18, 97, 0.7);\n}\n\n.link-inner[data-v-3fe857a2] {\n  color: var(--magic-tertiary, #311261);\n}", ""]);
// Exports
module.exports = exports;
